export default function clearEmptyValues<T = Record<string | number | symbol, unknown>>(value: T): {} | Partial<T> {
  const newValue = {};

  Object.keys(value).forEach((key) => {
    if (value[key] !== null && value[key] !== undefined && value[key] !== '') {
      newValue[key] = value[key];
    }
  });

  return newValue;
}
